<template>
  <div
    class="is-flex is-align-items-center is-justify-content-center break-window-size"
    :style="{ backgroundColor: backgroundColor }">
    <div class="has-text-centered">
      <div v-if="relevantBreaks">
        <div v-if="exceedBy > 0">
          <p class="mb-6 has-text-weight-bold has-text-danger is-size-3">שימי לב, זמן ההפסקה היומי הוא 45 דקות, חרגת ממנו היום ב: {{ exceedBy }} דקות</p>
        </div>
        <div v-if="warningText">
          <p class="mb-6 has-text-weight-bold has-text-black is-size-3">{{ warningText }}</p>
        </div>
        <div class="mb-6">
          <p>Current time break: {{ currBreak }} min </p>
          <p>Daily sum breaks : {{ dailyBreakSum }} min </p>
        </div>
      </div>
      <button class="button is-info" @click="onClick">
        {{ buttonTitle }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

const MAXDAILYBREAK = 45
const LUNCHBREAK = 30

export default {
  name: 'BreakStatusModal',
  props: {
    buttonTitle: {
      type: String
    },
    bgColor: {
      type: String
    },
    statDesignator: {
      type: String
    },
    alertId: {
      type: [Number, String]
    }
  },
  data () {
    return {
      timer: null,
      breakTime: this.$moment().startOf('day'),
      timerStart: this.$moment().startOf('day'),
      timePassed: '00:00:00',
      dailyBreakSum: 0,
      currBreak: 0,
      beepLunch: false,
      backgroundColor: this.bgColor,
      warningText: undefined
    }
  },
  computed: {
    relevantBreaks () {
      return ['break_end', 'lunch_break_end'].includes(this.statDesignator)
    },
    exceedBy () {
      return this.currBreak + this.dailyBreakSum - MAXDAILYBREAK
    }
  },
  created () {
    this.timer = setInterval(this.setTimer, 1000)
    localStorage.removeItem('isBreakOn')
    this.onRefresh()
    this.$network_utils
      .getStats({
        designator: 'break_end,lunch_break_end',
        owner: this.$utils.getOwner().name,
        date_from: this.$moment().startOf('day').toString(),
        date_to: this.$moment().endOf('day').toString()
      })
      .then((response) => {
        this.dailyBreakSum = response.reduce((prev, curr) => prev + parseInt(curr.content), 0)
      })
  },
  methods: {
    ...mapMutations('modals', ['removeModalById']),
    setTimer () {
      this.breakTime.add(1, 'second')
      this.timePassed = this.breakTime.format('HH:mm:ss')
      this.currBreak = this.breakTime.diff(this.timerStart, 'minutes')
      if (MAXDAILYBREAK - this.dailyBreakSum > LUNCHBREAK && this.statDesignator == 'lunch_break_end' && this.currBreak >= LUNCHBREAK && !this.beepLunch) {
        this.backgroundColor = 'red'
        this.beep()
        this.beepLunch = true
        this.warningText = 'שימי לב, זמן הפסקת צהריים עבר'
        return
      }
      if (MAXDAILYBREAK - this.dailyBreakSum < LUNCHBREAK && this.currBreak + this.dailyBreakSum >= MAXDAILYBREAK && this.statDesignator == 'lunch_break_end' && !this.beepLunch) {
        this.backgroundColor = 'red'
        this.beep()
        this.beepLunch = true
        this.warningText = 'שימי לב, זמן ההפסקה היומית עבר'
        return
      }
      if (this.statDesignator == 'lunch_break_end' && this.currBreak >= LUNCHBREAK && !this.beepLunch) {
        this.beep()
        this.beepLunch = true
      }
    },
    onClick () {
      clearInterval(this.timer)
      const breakTime = this.breakTime.diff(this.timerStart, 'minutes')
      this.$network_utils
        .postStat({
          resource_type: 'Admin',
          resource_id: this.$utils.getOwner().id,
          designator: this.statDesignator,
          title: this.statDesignator
            .replace('_', ' ')
            .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase()),
          content: breakTime,
          owner: this.$utils.getOwner().name
        })
        .then(() => {
          localStorage.removeItem('isBreakOn')
          this.saveTheTime(breakTime)
          this.removeModalById(this.$attrs.payload.modal_id)
        })
    },
    onRefresh () {
      const data = {
        modal_title: this.$attrs.payload.modal_title,
        bgColor: this.backgroundColor,
        statDesignator: this.statDesignator
      }
      const breakTime = this.breakTime.diff(this.timerStart, 'minutes')
      this.saveTheTime(breakTime)
      localStorage.setItem('isBreakOn', JSON.stringify(data))
    },
    saveTheTime (breakTime) {
      const breaks = JSON.parse(localStorage.getItem('missionBreakTimes') || '[]')
      breaks.push(breakTime)
      localStorage.setItem('missionBreakTimes', JSON.stringify(breaks))
    },
    beep () {
      const context = new AudioContext()
      const oscillator = context.createOscillator()
      oscillator.type = 'sine'
      oscillator.frequency.value = 500
      oscillator.connect(context.destination)
      oscillator.start()
      setTimeout(function () {
        oscillator.stop()
      }, 1000)
    }
  }
}
</script>

<style scoped>
.break-window-size {
  height: 70vh;
}
</style>
